/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Action_UnpublishInputs */

const cs_action_unpublish = /** @type {(inputs: Action_UnpublishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skrýt`)
};

const en_action_unpublish = /** @type {(inputs: Action_UnpublishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unpublish`)
};

/**
* | output |
* | --- |
* | "Unpublish" |
*
* @param {Action_UnpublishInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const action_unpublish = /** @type {((inputs?: Action_UnpublishInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Action_UnpublishInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_action_unpublish(inputs)
	return cs_action_unpublish(inputs)
});